<div class="fixed inset-0 z-40 bg-neutral-900/30" (click)="closeRequested.emit()"></div>
<aside
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  class="fixed top-0 end-0 z-50 h-full bg-white shadow-xl flex flex-col"
  [class.w-full]="true"
  [class.md:w-1/2]="wide()"
  [class.md:w-[28rem]]="!wide()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="title()">
  <header class="flex items-center justify-between border-b border-neutral-200 px-2xl py-lg">
    <h2 class="text-lg font-semibold text-neutral-900">{{ title() }}</h2>
    <button type="button" id="custom_workflow_drawer_close" class="text-neutral-500 text-xl" aria-label="close" (click)="closeRequested.emit()">✕</button>
  </header>
  <div class="flex-1 overflow-y-auto px-2xl py-xl"><ng-content /></div>
</aside>
